import React, { useState } from "react";
import { useNavigate,Link } from "react-router-dom"; // Import for routing
import { FaPhoneAlt, FaSearch, FaCheck, FaArrowRight } from "react-icons/fa";
import "../Css/CookingMaid.css";
import coockingImage from "../assets/service-4.jpg";




const CookingMaid = () => {

    const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  // List of your services
  const services = [
  { name: "Patient Care", path: "/services/patient-care-service-in-mumbai" },
  { name: "Baby Care", path: "/services/baby-care-service-in-mumbai" },
  { name: "House Maid", path: "/services/house-maid-service-in-mumbai" },
  { name: "Cooking", path: "/services/cooking-service-in-mumbai" },
  { name: "Driver", path: "/services/driver-service-in-mumbai" },
  { name: "Home Cleaning", path: "/services/home-cleaning-service-in-mumbai" },
  { name: "Japa Maid", path: "/services/japa-maid-service-in-mumbai" },
];

  // Filter logic
  const filteredServices = services.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  
  return (
    <div className="CookingMaid-page">
      {/* HERO SECTION - RETAINED AS REQUESTED */}
      <section className="CookingMaid-hero">
        <div className="CookingMaid-overlay">
          <div className="CookingMaid-hero-content">
            <h1>Cooking Maid Service</h1>
            <p>
              <span><a href="/">Home</a></span> / <span className="active">Cooking Maid Service</span>
            </p>
          </div>
        </div>
      </section>

      {/* SQUARE PREMIUM CONTENT */}
      <section className="main-section">
        <div className="container-square">
          <div className="content-layout">
            
            {/* Main Content Area */}
            <div className="article-box">
              <div className="square-img-holder">
                <img src={coockingImage} alt="Cooking Maid Services" />
                <div className="img-overlay-label">PREMIUM SERVICE</div>
              </div>

              <div className="text-header">
                <h2 className="title-bold">Cook Service in Mumbai - Hire Cooking Maid Service</h2>
                <h4 className="subtitle-line">Hire Professional Cook in Mumbai</h4>
              </div>

              <div className="body-description">
                <p>SVK Maid Service is a trusted Cook Service Agency Mumbai, providing skilled and professional cooking maids to households across the city. We specialize in offering reliable culinary support that ensures every meal is prepared with care, hygiene, and attention to taste. Our mission is to make home cooking convenient and stress-free for busy families.</p>
                <p>With SVK Maid Service, you can easily Hire Cooking Maid Mumbai who is trained to handle all kitchen tasks efficiently. From daily meal preparation to managing special dietary needs and festive cooking, our experienced maids bring professionalism, consistency, and reliability to your home.</p>
                <p>We provide Professional Cook Service Mumbai with a focus on quality, cleanliness, and culinary excellence. Every cooking maid is background-verified, skilled in a variety of cuisines, and committed to delivering a seamless cooking experience for your family.</p>
                
              </div>

              {/* Why Choose - Modern Square Grid */}
              <div className="why-choose-square">
                <h3>Why Choose SVK Maid Service?</h3>
                <div className="grid-features">
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Experienced Cooking Maid Mumbai:</strong> Skilled in preparing nutritious meals and managing kitchen operations effectively.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Trusted Cooking Maid Mumbai:</strong> Verified, reliable, and professional staff for consistent household support.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Professional Cook Service Mumbai:</strong> Trained to cook a wide range of cuisines, keeping taste and hygiene in mind.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Flexible Options:</strong> Full-time, part-time, or hourly cooking maid services tailored to your requirements.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Personalized Service:</strong> Maids matched according to your family’s dietary preferences and schedule.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Customer Assistance:</strong> Our team ensures smooth communication and support for a hassle-free experience.</p>
                  </div>
                </div>
              </div>

              <div className="summary-footer-box">
                <p>At SVK Maid Service, our Experienced Cooking Maid Mumbai do more than just cook—they maintain a clean and organized kitchen, help with meal planning, and ensure that every dining experience at home is enjoyable and stress-free.</p>
              </div>
              <div className="summary-footer-box">
                <p>Choosing SVK Maid Service guarantees access to a dedicated and skilled cooking maid who brings professionalism, reliability, and convenience to your home. As a Cook Service Agency Mumbai, we take pride in delivering high-quality services that families across Mumbai trust for their culinary needs.</p>
              </div>
              <div className="summary-footer-box">
                <p>Experience the ease and comfort of having a dedicated cooking maid in your home. With SVK Maid Service, you can Hire Cooking Maid Mumbai confidently, knowing that every meal will be prepared with precision, hygiene, and care.</p>
              </div>
            </div>

            {/* Square Sidebar */}
            <aside className="sidebar-square">
              {/* ACTIVE SEARCH BOX */}
      <div className="search-container-premium">
        <div className="search-square">
          <input
            type="text"
            placeholder="SEARCH SERVICES..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button><FaSearch /></button>
        </div>

        {/* Search Results Dropdown */}
        {searchTerm && (
          <div className="search-results-dropdown">
            {filteredServices.length > 0 ? (
              filteredServices.map((service, index) => (
                <div
                  key={index}
                  className="result-item"
                  onClick={() => navigate(service.path)}
                >
                  {service.name}
                </div>
              ))
            ) : (
              <div className="no-result">No services found</div>
            )}
          </div>
        )}
      </div>

              <div className="list-widget">
                <h5>OUR SERVICES</h5>
                <ul className="square-links">
  <li>
    <Link to="/services/patient-care-service-in-mumbai">
      Patient Care <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/baby-care-service-in-mumbai">
      Baby Care <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/house-maid-service-in-mumbai">
      House Maid <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link
      to="/services/cooking-service-in-mumbai"
      className="active-item"
    >
      Cooking <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/driver-service-in-mumbai">
      Driver <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/home-cleaning-service-in-mumbai">
      Home Cleaning <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/japa-maid-service-in-mumbai">
      Japa Maid <FaArrowRight />
    </Link>
  </li>
</ul>
              </div>

<div className="contact-box-square">
  <div className="cta-overlay-square">
    <div className="cta-icon-square">
      <FaPhoneAlt />
    </div>
    <h3 className="cta-title-square">Call us Today!</h3>
    <a href="tel:+919152151180" className="cta-phone-square">
      +91 91521 51180
    </a>
    <a href="mailto:info@svkmaidservice.com" className="cta-email-square">
      info@svkmaidservice.com
    </a>
  </div>
</div>
            </aside>

          </div>
        </div>
      </section>
    </div>
  );
};

export default CookingMaid;